'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _InputGroup = require('react-bootstrap/lib/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _commonFormsy = require('../common-formsy');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LIEN_FEE_TYPE = _constants.AppConstants.LIEN_FEE_TYPE;

var FEE_TYPE_OPTIONS = _commonFormsy.Dropdown.getOptionsFromObject(LIEN_FEE_TYPE);

var GenericFeeRow = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(GenericFeeRow, _Component);

  function GenericFeeRow() {
    _classCallCheck(this, GenericFeeRow);

    return _possibleConstructorReturn(this, (GenericFeeRow.__proto__ || Object.getPrototypeOf(GenericFeeRow)).apply(this, arguments));
  }

  _createClass(GenericFeeRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          fee = _props.fee,
          idx = _props.idx,
          label = _props.label;

      return _react2.default.createElement(
        _Row2.default,
        { key: idx, className: 'fee-row' },
        _react2.default.createElement(
          _Col2.default,
          { lg: 6, md: 6, sm: 6, className: 'col-first' },
          _react2.default.createElement(_commonFormsy.Input, {
            name: 'fees[' + idx + '].id',
            type: 'hidden',
            value: fee.id
          }),
          _react2.default.createElement(_commonFormsy.Input, {
            name: 'fees[' + idx + '].contributes_to_principal', value: fee.contributes_to_principal,
            type: 'hidden'
          }),
          _react2.default.createElement(_commonFormsy.Dropdown, {
            name: 'fees[' + idx + '].fee_type',
            label: 'Fee type',
            options: FEE_TYPE_OPTIONS,
            value: fee.fee_type,
            validations: { isRequiredFor: 'fees[' + idx + '].fee_amount' },
            validationErrors: {
              isRequiredFor: 'Fee type is required.'
            }
          })
        ),
        _react2.default.createElement(
          _Col2.default,
          { lg: 6, md: 6, sm: 6, className: 'col-second' },
          _react2.default.createElement(_commonFormsy.Input, {
            addonAfter: _react2.default.createElement(
              _InputGroup2.default.Addon,
              null,
              '$'
            ),
            name: 'fees[' + idx + '].fee_amount',
            label: label + ' Amount',
            validations: {
              isNumeric: true,
              isPositive: true
            },
            validationErrors: {
              isNumeric: label + ' Amount must be a valid amount.',
              isPositive: label + ' Amount must be positive.'
            },
            value: fee.fee_amount,
            type: 'number'
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return GenericFeeRow;
}(_react.Component), _class2.propTypes = {
  fee: _propTypes2.default.object,
  idx: _propTypes2.default.number,
  label: _propTypes2.default.string
}, _temp)) || _class;

var _default = GenericFeeRow;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LIEN_FEE_TYPE, 'LIEN_FEE_TYPE', '/app/src/components/page-case/GenericFeeRow.js');
  reactHotLoader.register(FEE_TYPE_OPTIONS, 'FEE_TYPE_OPTIONS', '/app/src/components/page-case/GenericFeeRow.js');
  reactHotLoader.register(GenericFeeRow, 'GenericFeeRow', '/app/src/components/page-case/GenericFeeRow.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/GenericFeeRow.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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